<template>
    <div class="qksm qksm9">
        <h4>九、国有资本经营预算财政拨款收入支出情况说明</h4>
        <div class="nogap">
            <p>
                2020年国有资本经营预算上年结转和结余{{isMoney(T9.结转和结余)}}万元，本年收入{{isMoney(T9.本年收入)}}万元，
                本年支出{{isMoney(T9.本年支出)}}万元，年末结转和结余{{isMoney(T9.年末结转和结余)}}万元。
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm9",
        props: {
            T9: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        data() {
            return {
                isPdf: this.$parent.isPdf,
            }
        },
    };
</script>
